<template>
    <v-card class="mx-auto"
            max-width="90%"
            elevation="10"
            >
        <v-list-item two-line>
            <v-list-item-content>
                <v-col cols="12">
                    <v-list-item-title class="text-h5">
                        {{ title }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{ desc }}
                    </v-list-item-subtitle>
                </v-col>
            </v-list-item-content>
        </v-list-item>
        <v-card-text>
            <v-row align="center">
                <v-col class="text-h4" cols="9">
                    {{ value }}
                </v-col>
                <v-col cols="3">
                    <v-icon
                        :color="iconColor"
                        x-large
                        >{{ icon }}</v-icon>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
    import axios from "axios";
    import { functions } from "../functions";
    import { EventBus } from "@/event-bus";
    import { signalLevelTools } from "../mixins/signalLevelTools.js";
    export default {

        name: "DashboardDaeeCardSignal",
        components: {
        },

        mixins: [signalLevelTools],

        props: {
            route: String,
            title: String,
            desc: String,
            dateStart: String,
            dateEnd: String,
            id: Number,
            update: Number
        },

        data: function () {
            return {
                rootApi: process.env.VUE_APP_ROOT_API,
                value: "-",
                iconColor: "-",
                icon: "",
            };
        },

        created: function () {
            this.wSDataRequest();
        },
        computed: {

        },
        watch: {
            update(newValue, oldValue) {
                this.wSDataRequest();
            }
        },
        afterCreate: function () {
        },
        beforeCreate: function () {

        },

        methods: {

            wSDataParseResponse(response) {

                let value = parseInt(response.value);

                if (isNaN(value)) {
                    value = false;
                }

                if (value < -200) {
                    value = false;
                }

                if (value > 1000) {
                    value = false;
                }

                this.icon = this.getIconByValue(value);
                this.value = value === false ? "Indisponível" : value;
            },

            wSDataRequest() {
                const url = `${this.rootApi}/${this.route}/${this.id}/${this.parseDateToUrl(this.dateStart)}/${this.parseDateToUrl(this.dateEnd)}`;

                axios
                        .get(url, axios.getHeaders())
                        .then((response) => {
                            this.wSDataParseResponse(response.data);
                        })
                        .catch((err) => {
                            return functions.parseCatch(err, this.$appMessages.err404);
                        });
            },

            parseDateToUrl(date) {
                return date.replaceAll("/", "-");
            }
        }
    };
</script>

<style>

</style>
